<template>
  <!-- AKTIVNÍ ODKAZ -->
  <router-link 
    v-if="url" 
    :to="url" 
    class="moniex-nav-link d-flex align-items-center" 
    :class="{
      'moniex-nav-link-dark': isDarkMode,
      'is-current': isCurrent
    }"
    v-bind="$attrs" 
    @click="hideMobileNav"
  >
    <div class="moniex-icon-wrap">
      <slot name="icon"></slot>
    </div>
    <span class="moniex-link-text">{{ navText }}</span>
  </router-link>

  <!-- NEAKTIVNÍ / TLAČÍTKO -->
  <a 
    v-else 
    href="javascript:;" 
    class="moniex-nav-link d-flex align-items-center" 
    :class="{ 'moniex-nav-link-dark': isDarkMode }"
    v-bind="$attrs" 
    @click.capture="hideMobileNav"
  >
    <div class="moniex-icon-wrap">
      <slot name="icon"></slot>
    </div>
    <span class="moniex-link-text">{{ navText }}</span>
  </a>
</template>

<script>
export default {
  name: "sidenav-item",
  props: {
    url: { type: String, required: false },
    navText: { type: String, required: true }
  },
  computed: {
    isDarkMode() {
      return !!this.$store.state.isDarkMode;
    },
    isCurrent() {
      const path = this.$route.path || '/';
      const url = this.url;
      if (!url) return false;
      if (url === '/') return path === '/';
      if (url === '/aktualni-hry') {
        return path === '/aktualni-hry' || path.startsWith('/bezici-hra/');
      }
      if (url === '/ukoncene-hry') {
        return path === '/ukoncene-hry' || path.startsWith('/ukoncena-hra/');
      }
      if (url === '/top-20') {
        return path === '/top-20' || path.startsWith('/hrac/');
      }
      return path === url || path.startsWith(`${url}/`);
    }
  },
  methods: {
    hideMobileNav() {
      if (window.innerWidth < 1200) {
        this.$store.commit('navbarMinimize');
      }
    }
  }
};
</script>

<style scoped>
/* 🎯 ZÁKLADNÍ POLOŽKA MENU (PŘESNĚ PODLE PREZENTACE) */
.moniex-nav-link {
  display: flex !important;
  align-items: center !important;
  padding: 4px 14px !important;
  margin-left: 16px !important;
  margin-right: 16px !important;
  margin-bottom: 0 !important;
  border-radius: 25px !important;   /* Plné pilulkové zaoblení konců */
  color: #64748B !important;        /* Elegantní tlumená šedá textu */
  text-decoration: none !important;
  font-family: "Ubuntu Sans", Ubuntu, sans-serif !important;
  transition: all 0.15s ease-in-out !important;
  background-color: transparent !important;
}

/* Obal pro ikonku */
.moniex-icon-wrap {
  width: 24px !important;
  height: 24px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-right: 14px !important;    /* Větší mezera mezi ikonou a textem */
  background: none !important;
}

/* Vynucená šedá barva pro neaktivní ikony */
.moniex-icon-wrap :deep(i),
.moniex-icon-wrap :deep(svg) {
  color: #64748B !important;        /* Ikona drží stejnou barvu jako text */
  font-size: 1.25rem !important;    /* Čistá, čitelná velikost */
  opacity: 1 !important;
  transition: color 0.15s ease !important;
}

/* Styl pro samotný text */
.moniex-link-text {
  font-size: 0.95rem !important;
  font-weight: 500 !important;      /* Středně tučné písmo podle Moniexu */
  letter-spacing: -0.1px !important;
}

/* HOVER STAV: Když na položku najedeš myší */
.moniex-nav-link:hover:not(.is-current) {
  background-color: #F8FAFC !important; /* Velmi jemný šedý nádech pozadí */
  color: #0F172A !important;           /* Text ztmavne na maximum */
}
.moniex-nav-link:hover:not(.is-current) .moniex-icon-wrap :deep(i),
.moniex-nav-link:hover:not(.is-current) .moniex-icon-wrap :deep(svg) {
  color: #FF6A33 !important;
}

/* Aktuální stránka */
.moniex-nav-link.is-current,
.moniex-nav-link.is-current:hover {
  background-color: #F1F5F9 !important;
  color: #0F172A !important;
  box-shadow: none !important;
}

.moniex-nav-link.is-current .moniex-icon-wrap :deep(i),
.moniex-nav-link.is-current .moniex-icon-wrap :deep(svg),
.moniex-nav-link.is-current:hover .moniex-icon-wrap :deep(i),
.moniex-nav-link.is-current:hover .moniex-icon-wrap :deep(svg) {
  color: #FF6A33 !important;
}

.moniex-nav-link-dark {
  color: #CBD5E1 !important;
}

.moniex-nav-link-dark .moniex-icon-wrap :deep(i),
.moniex-nav-link-dark .moniex-icon-wrap :deep(svg) {
  color: #94A3B8 !important;
}

.moniex-nav-link-dark:hover:not(.is-current) {
  background-color: #1E293B !important;
  color: #E2E8F0 !important;
}

.moniex-nav-link-dark:hover:not(.is-current) .moniex-icon-wrap :deep(i),
.moniex-nav-link-dark:hover:not(.is-current) .moniex-icon-wrap :deep(svg) {
  color: #FF6A33 !important;
}

.moniex-nav-link-dark.is-current,
.moniex-nav-link-dark.is-current:hover {
  background-color: #1E293B !important;
  color: #E2E8F0 !important;
  box-shadow: none !important;
}

.moniex-nav-link-dark.is-current .moniex-icon-wrap :deep(i),
.moniex-nav-link-dark.is-current .moniex-icon-wrap :deep(svg),
.moniex-nav-link-dark.is-current:hover .moniex-icon-wrap :deep(i),
.moniex-nav-link-dark.is-current:hover .moniex-icon-wrap :deep(svg) {
  color: #FF6A33 !important;
}

/* 💥 TOTÁLNÍ DEMOLICE ARGON OBÁLKY SIDEBARU (PŘEPIS ZMRAŽENÉHO LAYOUTU) */

/* Překopání samotného levého panelu na plovoucí bílou desku */
:global(.navbar-vertical.navbar) {
  background-color: #FFFFFF !important;
  border-radius: 20px !important;    /* Krásné zakulacené rohy celého menu */
  margin: 12px 20px 20px 20px !important;
  height: calc(100vh - 32px) !important;
  max-width: 255px !important;        /* Pořádná fixní šířka jako na Moniex obrázku */
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03) !important; /* Ultra jemný elegantní stín */
  border: 1px solid #F1F5F9 !important; /* Tenká linka kolem desky */
}

:global(.navbar-vertical.navbar.sidenav-theme-dark),
:global(.navbar-vertical.navbar.sidenav-theme-dark.bg-white) {
  background-color: #0F172A !important;
  border: 1px solid #334155 !important;
  box-shadow: none !important;
  border-radius: 20px !important;
  margin: 12px 20px 20px 20px !important;
  height: calc(100vh - 32px) !important;
  max-width: 255px !important;
}

/* Fix pro vnitřní scrollování a zarovnání obsahu menu */
:global(#sidenav-collapse-main) {
  padding-left: 0 !important;
  padding-right: 0 !important;
  width: 100% !important;
}

:global(#sidenav-main .navbar-nav .nav-item) {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding: 0 !important;
}

:global(#sidenav-main .navbar-nav .nav-item.sidenav-section-label) {
  margin-top: 0.85rem !important;
  padding-top: 0.35rem !important;
}

/* Srovnání loga / hlavičky INGA nahoře, aby neutíkala ke kraji */
:global(.navbar-brand.sidenav-brand) {
  padding-left: 32px !important;
  padding-right: 16px !important;
  margin-top: 8px !important;
  margin-bottom: 4px !important;
}

@media (max-width: 430px) {
  :global(.navbar-vertical.navbar),
  :global(.navbar-vertical.navbar.sidenav-theme-dark),
  :global(.navbar-vertical.navbar.sidenav-theme-dark.bg-white) {
    margin: 8px !important;
    max-width: calc(100vw - 16px) !important;
    height: calc(100vh - 16px) !important;
  }

  :global(.navbar-brand.sidenav-brand) {
    padding-left: 18px !important;
  }

  .moniex-nav-link {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
}
</style>

